import { createQueryKeys } from '@lukemorales/query-key-factory'

import { regionService } from '@/domain/Regions'

export const regions = createQueryKeys('regions', {
    listRegions: () => ({
        queryKey: ['all'],
        queryFn: () => regionService.listRegions(),
    }),
})
